
import { IAnimalPreferenceData, ICropByCategory, IPreferenceType } from '@ninjacart/nc-nk-core';
import { AnimalFallBack, CropFallBack, ImageOrSvg, Text, TickSolid, useTheme, View, YStack } from '@ninjacart/nc-nk-ui';
import { Plus } from '@tamagui/lucide-icons';
import { Dimensions } from 'react-native';

export interface ICropProps {
  crop: ICropByCategory | IAnimalPreferenceData;
  isSelected: boolean;
  onSelect: () => void;
  regionalName: string | undefined;
  mediaUrl?: string;
  type: IPreferenceType;
  index?: number;
}

export const CropCard = ({ crop, isSelected, onSelect, regionalName, mediaUrl, type ,index}: ICropProps) => {
  const theme = useTheme();
  const screenWidth = Dimensions.get('window').width;
  const cardWidth = screenWidth / 4.5;
  return (
    <YStack
      key={crop?.id}
      alignItems="center"
      paddingHorizontal={8}
      paddingVertical={20}
      borderWidth={0.89}
      borderColor={isSelected ? '$primary' : '$grey'}
      borderRadius={7}
      width={cardWidth}
      margin={4}
      height={110}
      backgroundColor={isSelected ? '$expectAnswerCardBg' : '$cardbackground'}
      onPress={onSelect}
      style={{ position: 'relative' }}
      testID={`kisan_tId_userPreference_${index}`}
    >
      {mediaUrl ? (
        <ImageOrSvg
          uri={mediaUrl}
          width={50}
          height={50}
          borderWidth={1}
          borderRadius={type === IPreferenceType.CROP ? 30 : 2}
          borderColor={isSelected ? theme['primary']?.val : theme['cropBorderColor']?.val}
        />
      ) : (
        <View marginVertical={6}>
          {type == IPreferenceType.CROP ? (
            <CropFallBack
              width={50}
              height={50}
              borderColor={isSelected ? theme['primary']?.val : theme['cropBorderColor']?.val}
            />
          ) : (
            <AnimalFallBack width={40} height={40} />
          )}
        </View>
      )}
      <Text
        fontSize={14}
        fontWeight={'400'}
        color={isSelected ? theme['primary']?.val : theme['darkGrey']?.val}
        numberOfLines={1}
        paddingTop={4}
        ellipsizeMode="tail"
      >
        {regionalName ? regionalName : crop?.name}
      </Text>

      <YStack
        position="absolute"
        top={5}
        right={5}
        width={10}
        height={10}
        borderRadius={10}
        alignItems="center"
        justifyContent="center"
      >
        {isSelected ? (
          <TickSolid color="$color" size={14} />
        ) : (
          <YStack
            borderWidth={0.89}
            borderColor="$primary"
            borderRadius={10}
            borderStyle="dotted"
            alignItems="center"
            justifyContent="center"
            width={12}
          >
            <Plus color="$primary" size={13} />
          </YStack>
        )}
      </YStack>
    </YStack>
  );
};
